import React from 'react';
import PropTypes from 'prop-types';
import classnames from "classnames";

import {FaLock} from "react-icons/fa";

import Badge from "react-bootstrap/Badge";

const ScheduleBuilderOptionsTBA = function (props) {
    let component = null;
    let tbaEvents = [];

    // dig through the displayed events and find all day events (TBA)
    props.eventSources.map(eventObject => {
        eventObject.events.map(event => {
            // Add all day (TBA) to list of events for this component to show
            if (event.allDay) {
                tbaEvents.push({
                    classNames: eventObject.classNames, // replicate same css classes
                    title: event.title, // event title to display
                    extendedProps: event.extendedProps // replicate extendedProps (used for modal and display)
                });
            }
        });
    });

    if (tbaEvents.length > 0) {
        // determine the width of the TBA events to display
        let widthClass;
        switch (props.width) {
            case 6:
                widthClass = 'w-16'; // 6 items in a row, width = 16.6667%
                break;
            case 5:
            default:
                widthClass = 'w-20'; // 5 items in a row, width = 20%
        }

        let tbaListItems = tbaEvents.map((event, index) => {
            // build the display inside event
            let eventContent;

            if (event.extendedProps.indicator) {
                // Event badge
                let eventBadges;
                if (event.extendedProps.hasOwnProperty("badges") && event.extendedProps.badges.length > 0) {
                    eventBadges = event.extendedProps.badges.map((badge, i) => { return (
                        <div key={i}><Badge pill bg="white" className="text-dark text-uppercase fs-10">{badge}</Badge></div>
                    )});
                }

                // schedule option events
                eventContent =
                    <>
                        <span className="d-block lead"><strong><span className="sr-only">Schedule Option </span>{event.extendedProps.indicator}</strong></span>
                        <span className="d-block text-truncate">{event.title}</span>
                        {eventBadges}
                    </>;
            } else {
                // Event badge
                let eventBadges;
                if (event.extendedProps.hasOwnProperty("badges") && event.extendedProps.badges.length > 0) {
                    eventBadges = event.extendedProps.badges.map((badge, i) => { return (
                        <div key={i}><Badge pill bg="gray-dark" className="text-uppercase fs-10">{badge}</Badge></div>
                    )});
                }

                // registered course events
                eventContent =
                    <>
                        <span className="d-block text-muted">
                            <FaLock aria-hidden="true" />
                            <span className="sr-only">Registered Course</span>
                        </span>
                        <span className="d-block text-truncate text-muted">{event.title}</span>
                        {eventBadges}
                    </>;
            }

            // Borrowing some of the same style classes from fullcalendar library to keep consistent
            let cssClasses = classnames(
                "fc-event fc-timegrid-event fc-v-event fc-event-start fc-event-end",
                event.classNames.join(" "), // css classes of the same event group
            );

            const triggerEventModal = (jsEvent, event) => {
                if ([13, 32].includes(jsEvent.which)) {
                    jsEvent.preventDefault();
                    props.eventClick({event});
                }
            }

            return (
                <li key={index} className={`list-inline-item d-inline-block m-0 ${widthClass}`}>
                    <a tabIndex={0}
                       className={cssClasses}
                       style={{marginLeft: '3px', marginRight: '5px'}}
                       onClick={() => props.eventClick({event})}
                       onKeyPress={(e) => triggerEventModal(e, event)}>
                        <div className="fc-event-main px-1 pb-2">
                            {eventContent}
                        </div>
                    </a>
                </li>
            );
        });

        component =
            <div className="mt-3 fc" style={{marginLeft: '44px'}}>
                <strong className="text-uppercase mb-2">Sections without meeting time arranged:</strong>
                <ul className="list-inline mb-0">
                    {tbaListItems}
                </ul>
            </div>;
    }

    return component;
}

ScheduleBuilderOptionsTBA.propTypes = {
    eventSources: PropTypes.array.isRequired, // list of calendar events being displayed
    width: PropTypes.number.isRequired, // how many items are allowed in one row
    eventClick: PropTypes.func.isRequired // click event for tba items
}

export default ScheduleBuilderOptionsTBA;